<template>
    <div>
        <ul class="list_holder flex flex-col bg-blue">
            <li>
                <span>
                    {{ 'limitStaff' in price.custom_data ?
                        price.custom_data['limitStaff'] + ' Staff' :
                        'Unlimited Staff'
                    }}
                </span>
            </li>
            <li>
                <span>
                    {{ 'limitStudents' in price.custom_data ?
                        price.custom_data['limitStudents'] + ' Students' :
                        'Unlimited Students'
                    }}
                </span>
            </li>
            <li>
                <span>
                    {{ 'limitParents' in price.custom_data ?
                        price.custom_data['limitParents'] + ' Parents' :
                        'Unlimited Parents'
                    }}
                </span>
            </li>
            <li>
                <span>
                    {{ 'limitStorage' in price.custom_data ?
                        price.custom_data['limitStorage'] + ' GB Storage' :
                        'Unlimited Storage'
                    }}
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import { paddleMixin } from '@/mixins/paddle/paddle'

export default {
    mixins: [paddleMixin],
    components:{

    },
  props:{
        price:{
            type:Object,
            required:true,
            default:() => []
        }
    },
    data() {
        return {

        }
    },
    created() {

    },
    mounted () {

    },
    methods:{

    }
}
</script>